import type { FaireProductEntity } from "../../entity_types/product";

export const p_swqbrw8z2g: FaireProductEntity = {
  token: "p_swqbrw8z2g",
  type: "product",
  name: "Organic Everyday Extra Virgin Olive Oil - 3 Liter",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/365bb437fade0bd93c499f045121deb2c99dcd4dc28ca54daa14da6d5be27794.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2740a571f6a59be8c1cb95a92de894d67c6146e31cfacefaf925f67b80407080.jpeg",
    "https://cdn.faire.com/fastly/8d0208f1441211999cf6b556200e8c37db23527c48ebec1dc662ae00d410a695.jpeg"
  ],
  priceDollars: 60,
  description: "Cold pressed from organic Sicilian olives, our new Everyday Olive Oil is bright and balanced with a peppery finish. Grown across Sicily’s many micro climates, organic Sicilian heirloom olives are cold-pressed to create a pure extra virgin olive oil that is the best olive oil for cooking you can find. Designed to accompany your everyday recipes, savor the enduring flavors of Italy everyday.",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:23.934Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
